import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=loading, null=anon
  const [token, setToken] = useState(() => localStorage.getItem("bb_token"));

  const load = useCallback(async () => {
    if (!localStorage.getItem("bb_token")) {
      setUser(null);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("bb_token");
      setToken(null);
      setUser(null);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.mfa_required) return { mfaToken: data.mfa_token };
    return finish(data);
  };

  const verifyMfa = async (mfaToken, code) => {
    const { data } = await api.post("/auth/mfa/verify", { mfa_token: mfaToken, code });
    return finish(data);
  };

  const finish = (data) => {
    localStorage.setItem("bb_token", data.token);
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    localStorage.removeItem("bb_token");
    setToken(null);
    setUser(null);
  };

  const refreshUser = load;

  return (
    <AuthCtx.Provider value={{ user, token, login, verifyMfa, logout, refreshUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
